import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

import {getBaseUrl} from 'helpers/isCommandCenter';

export interface IAuthenticationResult {
  jwt: string;
}

export const authenticationApi = createApi({
  reducerPath: 'authentication',
  baseQuery: fetchBaseQuery({
    baseUrl: getBaseUrl(),
  }),
  endpoints(builder) {
    return {
      authenticate: builder.mutation<IAuthenticationResult, string>({
        query(accessToken) {
          return `auth?accessToken=${accessToken}`;
        },
      }),
    };
  },
});

export const {useAuthenticateMutation} = authenticationApi;
